import { CLUB_SELECTOR_PATH } from '@/features/auth/clubSelfRegistrationConfig.js'
import {
  buildLoginRouteQuery,
  getInvitationCodeFromQuery,
} from '@/features/auth/utils/authInvitationQuery.js'

function getFirstQueryValue(value) {
  return Array.isArray(value) ? value[0] : value
}

export async function applyPostLoginInvitationIfPresent({
  routeQuery = {},
  redirectUrl,
  vueRouter,
}) {
  const invitationCode = getInvitationCodeFromQuery(routeQuery)

  if (!invitationCode) {
    return { handled: false }
  }

  await vueRouter.push({
    path: CLUB_SELECTOR_PATH,
    query: buildLoginRouteQuery({
      invitationCode,
      activeClubId: getFirstQueryValue(routeQuery.activeClubId),
      email: getFirstQueryValue(routeQuery.email),
      redirectUrl: getFirstQueryValue(routeQuery.redirectUrl) || redirectUrl,
    }),
  })

  return { handled: true }
}
